import React, { useId } from 'react';

interface AiSparkleIconProps {
  size?: number;
}

/**
 * A colorful gradient sparkle icon representing AI/Atlas functionality.
 * Uses a purple-to-orange gradient for a modern AI aesthetic.
 * Each instance gets a unique gradient ID via React.useId() to avoid DOM collisions.
 */
const AiSparkleIcon: React.FC<AiSparkleIconProps> = ({ size = 16 }) => {
  const gradientId = useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7B2FF7" />
          <stop offset="50%" stopColor="#F107A3" />
          <stop offset="100%" stopColor="#FF9900" />
        </linearGradient>
      </defs>
      {/* Main 4-pointed star */}
      <path d="M12 2L13.5 9.5L21 12L13.5 14.5L12 22L10.5 14.5L3 12L10.5 9.5L12 2Z" fill={`url(#${gradientId})`} />
      {/* Small accent sparkle */}
      <path
        d="M19 2L19.5 4.5L22 5L19.5 5.5L19 8L18.5 5.5L16 5L18.5 4.5L19 2Z"
        fill={`url(#${gradientId})`}
        opacity="0.7"
      />
    </svg>
  );
};

export default AiSparkleIcon;
